module.exports = __webpack_public_path__ + "img/blowing_bubbles.ee69aca0.jpg";